import React, { Component } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import BusinessIcon from "@material-ui/icons/Business";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import { Redirect } from "react-router-dom";
import Addresses from "./Addresses";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { getPosition } from "../SecondStep/helpers";
import { Button } from "@material-ui/core";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("../SecondStep/gps.png" ||
    "leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("../SecondStep/gps.png" ||
    "leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

class DeliverTo extends Component {
  state = {
    drawerOpen: false,

    // This is for the map to refresh when you switch address as a logged in user
    mapKey: Math.random() * 1000,
    alHamraSituationTing: false,
  };

  renderAddressDetails = () => {
    const {
      language,
      address,
      areas,
      countries,
      settings,
      branch_delivery_charges,
    } = this.props;
    const translations = {
      Building: language == "english" ? "Building" : "مبنى",
      avenue: language == "english" ? "avenue" : "جادة",
      apartment:
        language == "english"
          ? address.selectedAddressType === 2
            ? "office"
            : "apartment"
          : address.selectedAddressType === 2
          ? "مكتب"
          : "شقة",
      paci: language == "english" ? "paci" : "الرقم الآلي",
      additional: language == "english" ? "additional" : "اضافي",
      floor: language == "english" ? "floor" : "الدور",
    };
    let selectedCountry = countries
      ? countries.find((country) => country.id == address.country)
      : null;
    const international = selectedCountry?.name === "International";

    let selectedArea;
    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      if (selectedArea) {
        selectedArea = {
          name: selectedArea.area,
          province_name: selectedArea.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    const useAddressLines =
      international || selectedArea?.province_name === "Kashtat";

    if (useAddressLines) {
      return (
        `${address.block}, ${address.street}` +
        (address.avenue ? ", " + address.avenue : "")
      );
    }
    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        ["Offices", "Mosques"].includes(selectedArea.province_name)) &&
      address.selectedDeliveryType === 0;

    if (
      selectedArea &&
      selectedArea.province_name === "Mosques" &&
      address.selectedDeliveryType === 0
    ) {
      return "";
    }

    if (!this.state.alHamraSituationTing && alHamraSituationTing) {
      this.setState({ alHamraSituationTing: true });
    }
    let tmp = alHamraSituationTing
      ? ""
      : `${translations["Building"]} ${address.building}`;
    if (address.avenue) tmp += `, ${translations["avenue"]} ${address.avenue}`;
    if (address.floor)
      tmp += alHamraSituationTing
        ? `${translations["floor"]} ${address.floor}`
        : `, ${translations["floor"]} ${address.floor}`;
    if (address.apartment)
      tmp += `, ${translations["apartment"]} ${address.apartment}`;
    if (address.location_id)
      tmp += `, ${translations["paci"]} ${address.location_id}`;
    if (address.additional)
      tmp += `, ${translations["additional"]}: ${address.additional}`;
    return tmp;
  };

  shouldShowMap = () => {
    if (
      this.props.settings.require_dine_in_contact_info &&
      this.props.settings.enable_table_qr
    )
      return false;
    if (
      (this.props.cart.delivered_items > 0 || this.props.cart.charged_items) &&
      (this.props.settings.enable_delivery || this.props.settings.enable_pickup)
    )
      return true;
    return false;
  };

  componentDidUpdate = (prevProps) => {
    const { settings, branch } = this.props;
    // This is for the map to refresh when you switch address as a logged in user
    if (
      prevProps.address?.lat !== this.props.address?.lat ||
      prevProps.address?.lng !== this.props.address?.lng ||
      (settings.is_branch_based_ordering &&
        (branch.branch !== prevProps.branch.branch ||
          branch.bdc !== prevProps.branch.bdc) &&
        this.props.auth.user)
    ) {
      if (!isNaN(prevProps.address?.lat))
        this.setState({ mapKey: Math.random() * 1000 });
    }
  };
  render() {
    const {
      language,
      settings,
      branch_delivery_charges,
      branch,
      areas,
      address,
      countries,
    } = this.props;

    const customTexts = settings.custom_texts;
    let areaName;
    let bdcObj = null;
    if (this.props.address && this.props.address.selectedDeliveryType == 0) {
      if (!settings.is_branch_based_ordering) {
        areaName = this.props.areas.find(
          (area) => area.id == this.props.address.area
        );
      } else {
        bdcObj = branch_delivery_charges.find((bdc) => bdc.id == branch.bdc);
        if (!bdcObj) return <Redirect to="/" />;
        areaName = {
          name: bdcObj.area,
          ar_name: bdcObj.area_ar,
          province_name: bdcObj.province_en,
        };
      }
    }

    let selectedCountry =
      countries && !!address
        ? countries.find((country) => country.id == address.country)
        : null;
    const international = selectedCountry?.name === "International";
    const useAddressLines =
      international || areaName?.province_name === "Kashtat";

    let isPickup = true;
    let pickupArea;
    let physicalProduct = true;

    if (
      !this.props.address ||
      (this.props.cart.delivered_items == 0 &&
        this.props.cart.charged_items == 0)
    ) {
      physicalProduct = false;
    }
    if (
      this.props.address &&
      this.props.address.selectedDeliveryType == 0 &&
      physicalProduct
    ) {
      isPickup = false;
    }
    if (
      !isPickup &&
      !this.props.address.area &&
      !settings.is_branch_based_ordering &&
      physicalProduct
    ) {
      return <Redirect to={"/checkout/address"} />;
    }
    const customerContact = this.props.customerContact;
    let countryName = this.props.store.base_country;
    if (physicalProduct && this.props.address && this.props.countries.length) {
      if (!settings.is_branch_based_ordering) {
        countryName = this.props.countries.find(
          (country) => country.id == this.props.address.country
        );
      } else {
        if (this.props.address.selectedDeliveryType == 0)
          countryName = this.props.countries.find(
            (country) => country.id == bdcObj.country_id
          );
        else {
          countryName = this.props.branches.find(
            (b) => b.id == branch.branch
          ).country;
        }
      }
      if (typeof countryName == "object") {
        if (countryName) countryName = countryName.name;
        else countryName = "Kuwait";
      }
    }

    if (isPickup && physicalProduct) {
      pickupArea = this.props.branches.find(
        (branch) => branch.id == this.props.address.pickupArea
      );
    }

    const interactionOptions = {
      zoomControl: false,
      doubleClickZoom: false,
      closePopupOnClick: false,
      dragging: false,
      zoomSnap: false,
      zoomDelta: false,
      trackResize: false,
      touchZoom: false,
      scrollWheelZoom: false,
    };

    let position;
    if (physicalProduct && !isPickup)
      position = getPosition(
        address,
        branch,
        branch_delivery_charges,
        areas,
        settings
      );
    if (pickupArea) {
      position = { lat: pickupArea.lat, lng: pickupArea.lng };
    }
    const alHamraSituationTing = this.state.alHamraSituationTing;

    const checkGiftUnknownLocation =
      this.props.settings.enable_gifts &&
      this.props.settings.enable_gifts_staff &&
      this.props.promise.isGift &&
      this.props.settings.enable_unknown_gift_recipient_location &&
      this.props.promise.unknown_location &&
      this.props.address?.selectedDeliveryType === 0;
    return (
      <>
        {this.state.drawerOpen && (
          <Addresses
            open={this.state.drawerOpen}
            onClose={() => this.setState({ drawerOpen: false })}
            comingFrom="confirmation"
          />
        )}
        <div style={{ marginTop: 30 }}>
          <p
            className="box-title"
            style={{ textAlign: language === "arabic" ? "right" : "left" }}
          >
            {(this.props.settings.enable_delivery ||
              this.props.settings.enable_pickup) &&
            physicalProduct &&
            !this.props.settings.require_dine_in_contact_info
              ? language == "english"
                ? isPickup
                  ? `${customTexts.pickup} from`
                  : "Deliver to"
                : isPickup
                ? `${customTexts.pickup_ar} من`
                : "توصيل الى"
              : language == "english"
              ? "Contact Information"
              : "معلومات التواصل"}
          </p>
          {this.shouldShowMap() &&
          !checkGiftUnknownLocation &&
          (!alHamraSituationTing || areaName.province_name === "Mosques") &&
          !useAddressLines &&
          settings.show_qr_pickup_directions &&
          !["aurapalma.enable.qa", "festivalarenafood.enable.qa"].includes(
            window.location.hostname
          ) &&
          !(
            this.props.address?.selectedDeliveryType === 0 &&
            !this.props.settings.ask_for_map_address
          ) ? (
            <div
              className="w-100 bordered"
              style={{ height: 140, position: "relative" }}
            >
              {(!pickupArea || (pickupArea.lat && pickupArea.lng)) && (
                <Button
                  onClick={() => {
                    if (!pickupArea) {
                      this.props.history.push("/checkout/address/map", {
                        checkout: true,
                      });
                    } else
                      window
                        .open(
                          `https://maps.google.com/maps?daddr=${pickupArea.lat},${pickupArea.lng}`,
                          "_blank"
                        )
                        .focus();
                  }}
                  style={{
                    background: "white",
                    position: "absolute",
                    [language === "arabic" ? "left" : "right"]: 15,
                    top: 10,
                    zIndex: 401,
                    top: 0,
                    bottom: 0,
                    marginTop: "auto",
                    marginBottom: "auto",
                    height: 35,
                    width: !!pickupArea
                      ? language === "arabic"
                        ? 90
                        : 120
                      : 75,
                    paddingLeft: language === "arabic" && 0,
                    boxShadow: "rgb(184 184 184) 1px 1px 1px 1px",
                    direction: language === "arabic" ? "rtl" : "ltr",
                  }}
                  variant="outlined"
                  color="primary"
                  endIcon={
                    <NavigateNextIcon
                      style={{
                        transform: language === "arabic" && "rotate(180deg)",
                      }}
                    />
                  }
                  className="bold"
                >
                  <span style={{ marginLeft: language === "arabic" && 6 }}>
                    {!!pickupArea
                      ? language === "arabic"
                        ? "الاتجاهات"
                        : "Directions"
                      : language === "arabic"
                      ? "تعديل"
                      : "Edit"}
                  </span>
                </Button>
              )}
              {(settings.ask_for_map_address ||
                address?.selectedDeliveryType !== 0) && (
                <MapContainer
                  key={this.state.mapKey}
                  center={
                    position || {
                      lat: settings.base_lat_lng?.split(",")[0],
                      lng: settings.base_lat_lng?.split(",")[1],
                    }
                  }
                  zoom={14}
                  {...interactionOptions}
                  style={{ height: 140, width: "99.9%" }}
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  {!!position && <Marker position={position} />}
                </MapContainer>
              )}
            </div>
          ) : (
            <></>
          )}
          {this.shouldShowMap() ? (
            <Link
              to={
                settings.enable_car_qr
                  ? "/checkout/confirmation"
                  : (!this.props.auth.user ||
                      !this.props.auth.addresses.length ||
                      isPickup) && {
                      pathname: "/checkout/address",
                      state: { prevPath: this.props.history.location.pathname },
                    }
              }
              onClick={() =>
                this.props.auth.user &&
                this.props.auth.addresses.length &&
                !isPickup &&
                this.setState({ drawerOpen: true })
              }
              style={{
                color: "black",
                cursor: "pointer",
              }}
            >
              <div
                className="border-top row w-100 mx-0 justify-content-between"
                style={{
                  backgroundColor: "white",
                  minHeight: isPickup ? 60 : 75,
                  padding: "20px 0px",
                }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                <div className="col-1 align-self-center">
                  <BusinessIcon style={{ color: "#5b5b5b" }} />
                </div>
                <div
                  className={"col-9 align-self-center ml-0 ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                  style={{
                    fontSize: "1rem",
                    fontWeight: 400,
                    [`padding${language === "arabic" ? "Left" : "Right"}`]: 0,
                  }}
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  {isPickup ? (
                    language == "english" ? (
                      pickupArea ? (
                        pickupArea.name
                      ) : (
                        ""
                      )
                    ) : pickupArea ? (
                      pickupArea.ar_name
                    ) : (
                      ""
                    )
                  ) : language == "english" ? (
                    <div
                      style={{
                        textAlign: "left",
                      }}
                    >
                      <p
                        className={
                          checkGiftUnknownLocation ||
                          !this.renderAddressDetails()
                            ? ``
                            : "mb-2"
                        }
                      >
                        <span className="bold">
                          {areaName ? areaName.name : ""}
                        </span>
                        {!checkGiftUnknownLocation && !useAddressLines && (
                          <>
                            {!["-", ""].includes(this.props.address.block) && (
                              <span>{`, ${
                                countryName == "Qatar" ? "zone" : "block"
                              } ${this.props.address.block}`}</span>
                            )}
                            {`${
                              this.props.address &&
                              this.props.address.street &&
                              this.props.address.street !== "-"
                                ? ", Str."
                                : ""
                            } ${
                              this.props.address?.street &&
                              this.props.address.street !== "-"
                                ? this.props.address.street
                                : ""
                            }`}
                          </>
                        )}
                      </p>
                      {!checkGiftUnknownLocation &&
                        this.renderAddressDetails() && (
                          <p className="m-0">{this.renderAddressDetails()}</p>
                        )}
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {!checkGiftUnknownLocation ? (
                        <>
                          {" "}
                          <p className="mb-2">{`${areaName.ar_name}، ${
                            countryName == "Qatar"
                              ? "منطقة"
                              : countryName === "Bahrain"
                              ? "مجمع"
                              : "قطعة"
                          } ${this.props.address.block}${
                            this.props.address && this.props.address.street
                              ? "، شارع"
                              : ""
                          } ${
                            this.props.address
                              ? this.props.address.street
                                ? this.props.address.street
                                : ""
                              : ""
                          }`}</p>{" "}
                        </>
                      ) : (
                        <p className="">{`${areaName.ar_name}`}</p>
                      )}
                      {!checkGiftUnknownLocation && (
                        <p className="m-0">{this.renderAddressDetails()}</p>
                      )}
                    </div>
                  )}
                </div>
                {
                  <div
                    className={"col-1 align-self-center mr-4 pr-0 ".concat(
                      language == "english" ? "text-right" : "text-left"
                    )}
                  >
                    {!settings.enable_car_qr && (
                      <EditIcon style={{ color: "#5b5b5b" }} />
                    )}
                  </div>
                }
              </div>
            </Link>
          ) : (
            <></>
          )}
          {/*Customer info*/}
          <Link
            to={{
              pathname: checkGiftUnknownLocation
                ? "/checkout/address"
                : "/checkout/details",
              state: { prevPath: this.props.history.location.pathname },
            }}
            style={{ color: "black", cursor: "pointer" }}
          >
            <div
              className={"row w-100 mx-0 justify-content-between ".concat(
                this.props.promise.isGift
                  ? ""
                  : this.shouldShowMap()
                  ? "border-bottom"
                  : "bordered"
              )}
              style={{
                backgroundColor: "white",
                minHeight: 25,
                paddingBottom: 20,
                paddingTop: this.shouldShowMap() ? 0 : 20,
              }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              <div className="col-1 align-self-center">
                <PermContactCalendarIcon style={{ color: "#5b5b5b" }} />
              </div>
              <div
                className={"col-9 align-self-center ml-0 ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
                style={{ fontSize: "1rem", fontWeight: 400 }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                {checkGiftUnknownLocation ? (
                  <p
                    style={{
                      margin: 0,
                      fontWeight: "bold",
                      color: this.props.themeColor,
                      fontSize: 14,
                    }}
                  >
                    {language === "english"
                      ? "Ask the receiver for details"
                      : "اسأل المستلم عن التفاصيل "}
                  </p>
                ) : (
                  <>
                    {" "}
                    {customerContact ? customerContact.name : ""},{" "}
                    <span className="bold">
                      {customerContact ? customerContact.phone : ""}
                    </span>
                  </>
                )}
              </div>
              <div
                className={"col-1 align-self-center mr-4 pr-0 ".concat(
                  language == "english" ? "text-right" : "text-left"
                )}
              >
                <EditIcon style={{ color: "#5b5b5b" }} />
              </div>
            </div>
          </Link>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    customerContact: state.customers.customerContact,
    areas: state.store.store.areas,
    branches: state.store.store.branches,
    cart: state.cart,
    settings: state.store.store.settings,
    countries: state.store.store.all_countries || state.store.store.countries,
    store: state.store.store,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branch: state.branch,
    auth: state.auth,
    promise: state.promise,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

export default connect(mapStateToProps)(DeliverTo);
